import {
  NavigationWithUserContext,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { MobileFullSimCardPage } from "@nju/feature-portal-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function MobileFullSimCard() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RequiredDashboardData extendedMode="mobile">
          <NavigationWithUserContext />
          <MobileFullSimCardPage flow="ONBOARDING" />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
